<template>
  <div>
    <Dialog
        :dismissableMask="true"
        :style="{ width: '35vw' }"
        :modal="true"
        :visible.sync="show"
        @hide="closeDialog"
        :contentStyle="{overflow: 'visible'}"
    >
      <template #header>
        <i style=" transform: scale(1.7); " class="pi pi-th-large"></i>
        <h1>הוספת הגד תעודה</h1>
      </template>
      <div class="p-pt-4 p-fluid p-grid">
<!--        <div class="p-field p-col-12 p-md-6">-->
<!--          <label for="id">שם מזהה</label>-->

<!--          <InputText   type="text" v-model="newItem.id" autofocus />-->
<!--        </div>-->
          <div class="p-field p-col-12 p-md-6">
              <label >מזהה</label>
              <InputNumber showButtons buttonLayout="horizontal" :step="1"  v-model="newItem.id" />
          </div>
        <div class="p-field p-col-12 p-md-6">
          <label >שם</label>
          <InputText  type="text" v-model="newItem.hebrewName" />
        </div>
 <div class="p-field p-col-12 p-md-6">
          <label >כמות כוכים</label>
          <InputNumber showButtons buttonLayout="horizontal" :step="1"  v-model="newItem.starsCount" />
        </div>
          <div class="p-field p-col-12 p-md-6">
              <label >תיאור האפשרויות, מופרד בסימן ׳,׳</label>
              <InputText  type="text" v-model="newItem.options" />
          </div>
          <div class="p-field p-col-12 p-md-6">
          <label >מקצוע</label>
          <select-lesson  v-on:onSelect="onChangeLesson" />
        </div>

      </div>


    <template #footer>
        <Button
            label="ביטול"
            icon="pi pi-times"
            @click="closeDialog"
            class="p-button-secondary"
        />
        <Button class="p-button-success" label="הוספה" icon="pi pi-check" @click="post"/>
      </template>
    </Dialog>
  </div>
</template>

<script>
import Service from "../../../../service/Service";
import axios from "axios";
import SelectLesson from "@/components/selects/SelectLesson";
const {v4: uuidv4} = require("uuid");

export default {
    components: {SelectLesson},
    service: null,
  props: {
    show: Boolean,
  },
  created() {
    this.service = new Service();
  },
  mounted() {
    this.setNewItwmFields();
  },
  data() {
    return {
      newItem: null,
    };
  },

  methods: {
      onChangeLesson(lesson){
          this.newItem.subject  = lesson.id
      },
    setNewItwmFields() {
      this.newItem = {
          id: null,
          hebrewName: null,
          starsCount: 3,
          options: "לא טוב, טוב, טוב מאוד",
           subject: null,
          active: true
          // private boolean active = true;
      };
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    async post() {
      let validate = true;
      for (const key in this.newItem) {
        if (this.newItem[key] === null) {
          validate = false;
        }
      }

      if (validate === true) {
        await axios.post("report/add-rating", this.newItem)
          .then((data) => {
            this.$emit("addItem", this.newItem);
            this.setNewItwmFields();
            this.openNotification(
              "success",
              `מעולה`,
              `זמן תעודה התווסף בהצלחה`
            );

            this.closeDialog();
          })
          .catch(() => {
            this.openNotification(
              "danger",
              `אופס`,
              `לא הצלחנו לעדכן במערכת`
            );
          });
      } else {
        this.openNotification(
          "danger",
          `אופס`,
          `חלק מהשדות חסרים או שגויים`
        );
      }
    },
    openNotification(color, title, text, position = "right-left", duration = 3000) {
      this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
    },
  },
};
</script>

<style >
</style>